import React from 'react';
import "./Services.css";
const Services = () => {
  return (
   
    <div className='services-container'>
        <div className='services-list-container'>
            <div className='services-list-desc'>
                <h1>
                    Here are my <span> skills</span>
                </h1>
                <p>I accomplish any task with genuine efforts and with proper planning. I am a sincere and hard-working person looking forward to contribute my ideas and apply my knowledge in different projects. </p>
                <button className='btn'
        role="link"
        onClick={() => window.open("https://github.com/SwaraliDhobale")}
      >
        Github
      </button>
            </div>
            <div className='services-item-container'>
            <div className='services-item'>
                <div className='item-desc'>
                    <h3> 📌Full Stack Web Development</h3>
                    <p>I possess a strong foundation in web development, proficient in HTML, CSS, and JavaScript. My experience extends to working with the MERN stack (MongoDB, Express.js, React, Node.js) and Flask framework. I am adept at designing intuitive user interfaces and implementing backend functionalities, ensuring seamless user experiences across different platforms. My skills in fullstack development enable me to contribute effectively to projects requiring robust web solutions.

</p>
                </div>
            </div>
            <div className='services-item'>
                <div className='item-desc'>
                    <h3>📌Machine Learning and Deep Learning</h3>
                    <p>I have undergone extensive training and internship programs focused on Artificial Intelligence and Machine Learning. My expertise includes working with convolutional neural networks (CNNs) and leveraging various Python libraries for data manipulation, modeling, and evaluation. I have applied machine learning algorithms to solve real-world problems, demonstrating a deep understanding of data analysis and predictive modeling techniques.</p>
                </div>
            </div>
            <div className='services-item'>
                <div className='item-desc'>
                    <h3>📌Cloud Computing</h3>
                    <p>My proficiency in cloud computing technologies allows me to deploy scalable and reliable solutions in cloud environments. I have experience working with cloud platforms such as AWS (Amazon Web Services) utilizing their services for storage, computation, and networking. I am skilled in configuring cloud infrastructure, ensuring optimal performance and security for applications and services.</p>
                </div>
            </div>
        </div>
        </div>
    </div>
  );
};

export default Services;